import { render, staticRenderFns } from "./language-selector.vue?vue&type=template&id=42eaf034"
import script from "./language-selector.vue?vue&type=script&lang=js"
export * from "./language-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports